import { Form, Modal } from "antd";

import FonteForm, { IFonteFormProps } from "../FonteForm";

interface IProps {
    visible: boolean;
    title: string;
    onClose: () => void;
    fonteFormProps: Omit<IFonteFormProps, "onCancel">;
}

export default function FonteFormModal({
    visible,
    title,
    onClose,
    fonteFormProps
}: IProps) {
    return (
        <Modal
            open={visible}
            title={title}
            footer={null}
            onCancel={onClose}
        >
            <Form layout="vertical">
                <FonteForm
                    onCancel={onClose}
                    cardStyle={{
                        border: 'none',
                        marginTop: 0,
                    }}
                    cardBodyStyle={{
                        padding: 0,
                    }}
                    {...fonteFormProps}
                />
            </Form>
        </Modal>
    )
}
